export default __webpack_public_path__ + "static/media/central.6b4a7ba8.jpg";